export default [
  {
    question: `What do I need to know?`,
    answer: `Staking via Unagii delegates to the Stakewithus Indexer to help index and curate data for the network. Rewards are earned by staking tokens and are paid out on every allocation date. Users can withdraw or compound at any time.`,
  },
  {
    question: `What is the inflation?`,
    answer: `The GRT token inflation is scheduled at 3% annually and query fees will be distributed based on subgraph activity and allocated stake ratio of the indexer.`,
  },
  {
    question: `Is there a lock-up period?`,
    answer: `There is a 28 days unthawing period when unstaking GRT from the network. Users will not earn rewards during this period.`,
  },
  {
    question: `How to restake?`,
    answer: `Users may manually withdraw rewards and restake to compound their returns.`,
  },
  {
    question: `Is there a fee?`,
    answer: `As delegators cannot be slashed for bad behavior, the protocol has a deposit tax of 0.5% on delegators to disincentivize poor decision making that could harm the integrity of the network. There is also a delegation commission fee paid to Stakewithus for staking.`,
  },
  {
    question: `What are the risks?`,
    answer: `Unique to The Graph, there are no slashing risks involved for delegation.`,
  },
];
